import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../../actions/actionCreators";

import MaterialModal from "../MaterialModal";
import Icon from "@material-ui/core/Icon";
import Table from "@material-ui/core/Table";
import TableHeader from "../../material-components/Table/TableHeader";
import TableBody from "../../material-components/Table/TableBody";

type Props = {
    modalProps: Object,
    isOpen: boolean,
    // Injected from Redux (ActionCreators)
    hideModal: string => void,
};

class DestinationRestrictedFieldsModal extends React.Component<Props> {
    hide = () => {
        this.props.hideModal("DESTINATION_RESTRICTED_FIELDS");
    };

    renderRestrictedTable = () => {
        const { modalProps } = this.props;
        if (!modalProps.Fields) {
            return null;
        }
        const tableHeaders = [
            ["FlowItem", "Flow Item"],
            ["FieldName", "Field Name"],
        ];
        const emptyMessage = ["EmptyMessage", ""];
        let data = [];
        modalProps.Fields.forEach(field => {
            data.push([
                ["FlowItem", `${field.FlowItemName}`, "smDown"],
                ["FieldName", field.FieldName, "smDown"],
            ]);
        });

        return (
            <div className="flow-edit-body" id="restrictionTable">
                <Table>
                    <TableHeader style={{ fontSize: "22px" }} headers={tableHeaders} ignoreHeaders={tableHeaders} />
                    <TableBody
                        style={{ fontSize: "18px" }}
                        data={data}
                        page={0}
                        rowsPerPage={data.length}
                        emptyMessage={emptyMessage}
                    />
                </Table>
            </div>
        );
    };

    render() {
        const { isOpen, modalProps } = this.props;
        let content = this.renderRestrictedTable();
        let header = `${modalProps.CompanyName} does not allow the use of the below fields`;
        return (
            <MaterialModal
                id="restricted-fields-modal"
                isOpen={isOpen}
                onClose={this.hide}
                title="Restricted Fields"
                showPrimaryButton={false}
                cancelButtonText="Close"
            >
                <div className="alert alert-warning-original flow-item-warnings" style={{ fontWeight: "bolder" }}>
                    <Icon style={{ marginRight: "10px", position: "relative", top: "2px" }}>error_outline</Icon>
                    {header}
                </div>
                {content}
            </MaterialModal>
        );
    }
}

const mapStateToProps = null;
const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);
const DestinationRestrictedFieldsModalC = connect(
    mapStateToProps,
    mapDispatchToProps
)(DestinationRestrictedFieldsModal);

import withModal from "../withModal";
const DestinationRestrictedFieldsModalCWM = withModal(
    DestinationRestrictedFieldsModalC,
    "DESTINATION_RESTRICTED_FIELDS"
);
export default DestinationRestrictedFieldsModalCWM;
